import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

// const getRolewiseProjectReport = async (params) => {
//     const data = await apiCall(
//       "post",
//       apiEndPoints.ROLEWISEPROJECTREPORT,
//       params
//     );
//     return data;
//   };

const getProjectDetailsReports = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROJECTDETAILSREPORT, params);
  return data;
};

const getDepostionReport = async (params) => {
  const data = await apiCall("post", apiEndPoints.DEPOSITIONREPORT, {
    ...params,
    suppressGlobalLoader: true,
  });
  return data;
};

const getMdocAuditLogs = async (params) => {
  const data = await apiCall("post", apiEndPoints.MDOC_AUDIT_LOGS, {
    ...params,
    suppressGlobalLoader: true,
  });
  return data;
};

const getMdocProperties = async () => {
  const data = await apiCall("post", apiEndPoints.MDOC_PROPERTIES, {
    suppressGlobalLoader: true,
  });
  return data;
};

const retryMdocPush = async (params) => {
  const data = await apiCall("post", apiEndPoints.MDOC_RETRY, {
    ...params,
    suppressGlobalLoader: true,
  });
  return data;
};

const getAllChanelPartnerData = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHANELPARTNERREPORT, params);
  return data;
};

const WebReportService = {
  // getRolewiseProjectReport,
  getProjectDetailsReports,
  getDepostionReport,
  getAllChanelPartnerData,
  getMdocAuditLogs,
  getMdocProperties,
  retryMdocPush,
};

export default WebReportService;
